export const TableEditConfirmation = {
    NONE: 'NONE',
    ROW: 'ROW',
    NO_CONFIRM_ROW: 'NO_CONFIRM_ROW',
    TABLE_TOP: 'TABLE_TOP',
    TABLE_BOTTOM: 'TABLE_BOTTOM'
};
//# sourceMappingURL=constants.js.map